import { DEFAULT_ORDER_TYPE } from 'modules/Orders/utils/orderTypeParam';
export var ORGANIZATIONS_LIST_PATH = '/organizations/';
export var ORGANIZATIONS_VIEW_PATH = "".concat(ORGANIZATIONS_LIST_PATH, ":id/");
export var ORGANIZATIONS_VIEW_TEAMS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "teams/:identifier/");
export var ORGANIZATIONS_MEMBERS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "members/");
export var ORGANIZATIONS_SERVERS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "servers/");
export var ORGANIZATIONS_SERVER_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "servers/:serverIdentifier/");
export var ORGANIZATIONS_TEAMS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "teams/");
export var ORGANIZATIONS_TEAM_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "teams/:teamIdentifier/");
export var ORGANIZATIONS_ORDERS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "orders/");
export var ORGANIZATIONS_GATEWAYS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "gateways/");
export var ORGANIZATIONS_GATEWAY_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "gateways/:gatewayIdentifier/");
export var ORGANIZATIONS_SETTINGS_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "settings/");
export var ORGANIZATIONS_ACTIVITY_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "activity/");
export var ORGANIZATIONS_NOTES_PATH = "".concat(ORGANIZATIONS_VIEW_PATH, "notes/");
export var ORGANIZATIONS_ORDER_CREATE_PATH = "".concat(ORGANIZATIONS_ORDERS_PATH, "create/:orderType?");
export var getOrdersPath = function getOrdersPath(orgId) {
    return ORGANIZATIONS_ORDERS_PATH.replace(':id', orgId);
};
export var getOrderCreatePath = function getOrderCreatePath(orgId) {
    var orderType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ORDER_TYPE;
    return "".concat(getOrdersPath(orgId), "create/").concat(orderType);
};
